import type { FilterValueDisplayObj } from '../../Entities/Search/SearchFilters/FilterValueDisplayObj.entity';

export const getFilterValueId = (filter: FilterValueDisplayObj) => {
  const valNoSpace = (filter.value || '').replace(/ /g, '');
  const valGteNoSpace = (filter.valueGte || '').replace(/ /g, '');
  const valLteNoSpace = (filter.valueLte || '').replace(/ /g, '');

  const valueId = `${valNoSpace}${valGteNoSpace}${valLteNoSpace}`;

  return valueId;
};
